import BestellungFiliale from "@/entities/common/bestellung_filiale"
import BestellungPending from "@/entities/common/bestellung_pending"
import ReservierungPending from "@/entities/common/reservierung_pending"
import Bestellung from "@/entities/common/bestellung"
import ReservierungNeu from "@/entities/common/reservierung_neu"

class Standort {
  bezeichnung?: string
  land?: string
  strasse?: string
  plz?: string
  ort?: string
  latitude?: number
  longitude?: number
}

export default class MainLogic {
  private static _instance: MainLogic = new MainLogic()

  standort: Standort = null
  neueBestellung: boolean = false
  neueReservierung: boolean = false

  private _filiale: BestellungFiliale = null
  private _bestellungPending: BestellungPending = new BestellungPending()
  private _reservierungPending: ReservierungPending = new ReservierungPending()
  private _bestellung: Bestellung = null
  private _reservierung: ReservierungNeu = null

  filialeListeners: (() => void)[] = []
  bestellungPendingListeners: (() => void)[] = []
  reservierungPendingListeners: (() => void)[] = []
  bestellungListeners: (() => void)[] = []
  reservierungListeners: (() => void)[] = []

  constructor() {
    this.standort = new Standort()
    this.bestellung = new Bestellung()
  }

  static getInstance() {
    return this._instance
  }

  static init() {
    this._instance = new MainLogic()
  }

  get bestellung(): Bestellung {
    return this._bestellung
  }

  set bestellung(newValue: Bestellung) {
    this._bestellung = newValue
    this.bestellungListeners.forEach((element) => {
      element()
    })
  }

  get reservierung(): ReservierungNeu {
    return this._reservierung
  }

  set reservierung(newValue: ReservierungNeu) {
    this._reservierung = newValue

    this.reservierungListeners.forEach((element) => {
      element()
    })
  }

  get filiale(): BestellungFiliale {
    return this._filiale
  }

  set filiale(newValue: BestellungFiliale) {
    this._filiale = newValue

    this.filialeListeners.forEach((element)=> {
      element()
    })
  }

  get bestellungPending(): BestellungPending {
    return this._bestellungPending
  }

  set bestellungPending(newValue: BestellungPending) {
    this._bestellungPending = newValue

    this.bestellungPendingListeners.forEach((element) => {
      element()
    })
  }

  get reservierungPending(): ReservierungPending {
    return this._reservierungPending
  }

  set reservierungPending(newValue: ReservierungPending) {
    this._reservierungPending = newValue

    this.reservierungPendingListeners.forEach((element) => {
      element()
    })
  }
}

export { Standort }
